import React, { startTransition, Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../assets/Courses/218dc37ca844a835bb8ab8f4e3b625bd.png";
import { TbArrowBadgeDownFilled } from "react-icons/tb";
import {
  FaGraduationCap,
  FaShieldAlt,
  FaCheck,
  FaCreditCard,
  FaLaptop,
  FaRocket,
  FaIdCard,
  FaCalendarAlt,
} from "react-icons/fa";
import { Helmet } from "react-helmet";

const NvqCourses = () => {
  const [activeTab, setActiveTab] = useState("construction-nvqs");
  const url = window.location.href.split("/");

  const navigate = useNavigate();
  const handleCardClick = (level) => {
    if (level.id >= 8) {
      const healthRoutes = {
        8: "/ohs-level-3",
        9: "/ohs-level-6",
        10: "/ohs-level-7",
      };
      startTransition(() => {
        navigate(healthRoutes[level.id]);
      });
    } else {
      startTransition(() => {
        navigate(`/nvq-level-${level.id}`);
      });
    }
  };

  const nvqLevels = [
    {
      id: 2,
      title: "Level 2 NVQs",
      subtitle: "Foundation Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Blue CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 3,
      title: "Level 3 NVQs",
      subtitle: "Intermediate Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Gold CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 4,
      title: "Level 4 NVQs",
      subtitle: "Higher Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Gold CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 5,
      title: "Level 5 NVQs",
      subtitle: "Advanced Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Black CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 6,
      title: "Level 6 NVQs",
      subtitle: "Degree Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Black CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 7,
      title: "Level 7 NVQs",
      subtitle: "Master's Level Qualifications",
      color: "from-red-800 to-red-900",
      icon: <FaGraduationCap className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Leading to Black CSCS card", icon: <FaIdCard /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
  ];

  const healthSafetyLevels = [
    {
      id: 8,
      title: "Level 3",
      subtitle: "Health & Safety Fundamentals",
      color: "from-red-800 to-red-900",
      icon: <FaShieldAlt className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 9,
      title: "Level 6",
      subtitle: "Advanced Health & Safety Practice",
      color: "from-red-800 to-red-900",
      icon: <FaShieldAlt className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
    {
      id: 10,
      title: "Level 7",
      subtitle: "Strategic Health & Safety Leadership",
      color: "from-red-800 to-red-900",
      icon: <FaShieldAlt className="text-white" />,
      benefits: [
        { text: "Klarna available at checkout", icon: <FaCreditCard /> },
        { text: "All remotely online portfolio", icon: <FaLaptop /> },
        { text: "Fast track completion", icon: <FaRocket /> },
        { text: "Instalment plans available", icon: <FaCalendarAlt /> },
      ],
    },
  ];

  useEffect(() => {
    setActiveTab(url[url.length - 1]);
  }, []);
  const title = "Construction NVQs | M2HSE Training";
  const description =
    "Gain qualifications with our expert-led Construction NVQ qualification across the United Kingdom. Flexible, accredited & tailored for your trade. Enrol today!";
  return (
    <Suspense
      fallback={
        <div className="h-screen w-full flex items-center justify-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-600"></div>
        </div>
      }>
      <div className="relative mt-20 max-w-screen-xl mx-auto bg-[#0C1524] min-h-screen">
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <link rel="canonical" href="https://m2hse.co.uk/construction-nvqs" />
          <link
            rel="canonical"
            href="https://m2hse.co.uk/nvq-level-courses/health-and-safety"
          />
        </Helmet>
        {/* Content */}
        <div className="relative z-10 mt-10 pt-28 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight">
              Professional{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-800">
                Qualification
              </span>{" "}
              Courses
            </h1>
            <p className="text-lg md:text-xl text-white max-w-3xl mx-auto">
              Advance your career with industry-recognized qualifications.
              Choose from our comprehensive range of courses designed to help
              you succeed.
            </p>
          </div>

          {/* Tabs Navigation */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <button
              className={`group relative overflow-hidden rounded-xl px-8 py-4 transition-all duration-300 ease-out ${
                activeTab === "construction-nvqs"
                  ? "text-[#0C1524] bg-white shadow-lg shadow-blue-500/25"
                  : "bg-gray-400/80 text-gray-800 hover:bg-gray-200"
              }`}
              onClick={() => {
                setActiveTab("construction-nvqs");
                window.location.href = "/construction-nvqs";
              }}>
              <span className="relative z-10 flex items-center justify-center gap-2 font-medium">
                <FaGraduationCap className="text-xl" />
                <span>NVQ Courses</span>
              </span>
            </button>

            <button
              className={`group relative overflow-hidden rounded-xl px-8 py-4 transition-all duration-300 ease-out ${
                activeTab === "health-and-safety-nvqs"
                  ? "text-[#0C1524] bg-white shadow-lg shadow-blue-500/25"
                  : "bg-gray-400/80 text-gray-800 hover:bg-gray-200"
              }`}
              onClick={() => {
                setActiveTab("health-and-safety-nvqs");
                window.location.href = "/health-and-safety-nvqs";
              }}>
              <span className="relative z-10 flex items-center justify-center gap-2 font-medium">
                <FaShieldAlt className="text-xl" />
                <span>Health and Safety Courses</span>
              </span>
              {activeTab === "health-and-safety-nvqs" && (
                <span className="absolute inset-0 z-0"></span>
              )}
            </button>
          </div>

          {/* Course Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {(activeTab === "construction-nvqs"
              ? nvqLevels
              : healthSafetyLevels
            ).map((level) => (
              <div
                key={level.id}
                onClick={() => handleCardClick(level)}
                className={`relative group overflow-hidden bg-white rounded-2xl transition-all duration-300 ease-out cursor-pointer hover:scale-[1.02] shadow-xl hover:shadow-2xl bg-gradient-to-br ${level.cardColor} dark:bg-gray-800 dark:border-gray-700`}>
                {/* Card Header */}
                <div
                  className={`p-4 bg-gradient-to-r ${level.color} text-white`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-bold">{level.title}</h3>
                      <p className="text-white/80 text-xs mt-1">
                        {level.subtitle}
                      </p>
                    </div>
                    <div className="text-3xl">{level.icon}</div>
                  </div>
                </div>

                {/* Card Body */}
                <div className="p-6 text-gray-800 dark:text-gray-200">
                  <h4 className="font-semibold text-lg mb-4">Key Benefits:</h4>
                  <ul className="space-y-3">
                    {level.benefits.map((benefit, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <span className="text-md mt-0.5 text-black dark:text-gray-300">
                          {benefit.icon}
                        </span>
                        <span className="text-md">{benefit.text}</span>
                      </li>
                    ))}
                  </ul>

                  {/* CTA Button */}
                  <div className="mt-8 flex justify-center">
                    <button
                      className={`w-2/3 py-2 px-2 rounded-xl font-medium text-white transition-all duration-300 text-md bg-gradient-to-r bg-[#0C1524] hover:shadow-lg transform hover:-translate-y-1`}>
                      Enquire Now
                    </button>
                  </div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-white/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            ))}
          </div>

          {/* Additional Info Section */}
          <div className="mt-16 md:mt-24 text-center">
            <h2 className="text-2xl font-bold text-white dark:text-white mb-8 md:text-3xl lg:text-4xl">
              Unlock Your Potential With Our Expert Courses
            </h2>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden transition-transform hover:scale-105">
                <div className="p-6">
                  <div className="w-12 h-12 bg-indigo-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                    <FaLaptop className="text-xl" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                    Learn From Anywhere
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    Our fully online courses provide the flexibility to study at
                    your own pace, from any device, anywhere in the world.
                  </p>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden transition-transform hover:scale-105">
                <div className="p-6">
                  <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                    <FaRocket className="text-xl" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                    Accelerate Your Career
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    Gain in-demand skills quickly with our focused, fast-track
                    learning options designed for efficiency.
                  </p>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden transition-transform hover:scale-105">
                <div className="p-6">
                  <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white">
                    <FaCalendarAlt className="text-xl" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                    Flexible Payment Solutions
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm">
                    We offer various payment methods, including installment
                    plans, to make quality education accessible to everyone.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default NvqCourses;
